const MIN_DAYS = 1
const MAX_DAYS = 400

export default function campaignExpirationDaysValidation (v) {
  if (!v) { return false }

  const parsedValue = parseInt(v)
  return parsedValue >= MIN_DAYS && MAX_DAYS >= parsedValue
}
